import React from "react";
import { KTMScreen, ActionEvent, RenderEvent, renderScreen } from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import {
  Layout,
  Dialog,
  Button,
  Display,
  Line,
  Card,
  Column,
  Panel,
} from "ktm-ui";
import CustomToolTip from "components/CustomToolTip";
import { CustomDropdown } from "components/CustomDropdown";
import "../../styles/Employee.css";
import moment from "moment";
import toastr from "toastr";
import { Modal } from "react-bootstrap";
import ReactButton from "react-bootstrap/Button";
import ReactMoment from "react-moment";
import InfoBox from "components/InfoBox";

interface IdsEmployee {
  Id: string;
  Policy_Id: string;
  FirstName: string;
  LastName: string;
  Email: string;
  MaidenName: string;
  Nickname: string;
  EmployeeNo: string;
  DateOfBirth: string;
  HireDate: string;
  BenefitCategory_Id: string;
  WaitingPeriodMonths: number;
  BenefitStartDate: string;
  HasProrating: boolean;
  FlexLaunchDate: string;
  FlexReminderDate: string;
  FlexLastDayReminderDate: string;
  FlexSelectionDeadline: string;
  SalaryMoney: number;
  TeladocWaitingPeriodMonths: number;
  PaApprovedBenefitStartDate: string;
  IsStartDateAdjusted: boolean;
}

interface IdsDependents {
  FirstName: string;
  LastName: string;
  DateOfBirth: string;
  Relation: string;
  IsStudent: boolean;
}

interface IdsPolicy {
  Id: string;
  IsActive: boolean;
  HasTeladoc: boolean;
}

interface IdsPolicyBenefitYear {
  Id: string;
  StartDate: string;
  EndDate: string;
}

const waitingPeriodMonths = [
  { value: null, label: "--Select--" },
  { value: 0, label: "None" },
  { value: 1, label: "1 month" },
  { value: 2, label: "2 months" },
  { value: 3, label: "3 months" },
  { value: 4, label: "4 months" },
  { value: 5, label: "5 months" },
  { value: 6, label: "6 months" },
  { value: 7, label: "7 months" },
  { value: 8, label: "8 months" },
  { value: 9, label: "9 months" },
  { value: 10, label: "10 months" },
  { value: 11, label: "11 months" },
  { value: 12, label: "12 months" },
];

const TeladocWaitingPeriodMonths = [
  { value: null, label: "--Select--" },
  { value: 0, label: "None" },
  { value: 1, label: "1 month" },
  { value: 2, label: "2 months" },
  { value: 3, label: "3 months" },
  { value: 4, label: "4 months" },
  { value: 5, label: "5 months" },
  { value: 6, label: "6 months" },
  { value: 7, label: "7 months" },
  { value: 8, label: "8 months" },
  { value: 9, label: "9 months" },
  { value: 10, label: "10 months" },
  { value: 11, label: "11 months" },
  { value: 12, label: "12 months" },
];

export default KTMScreen(
  { name: "planadmin.employee.add" },
  class extends React.Component<{ policy_id: string }> {
    private screen!: any;

    data: {
      dsEmployee: IdsEmployee;
      dsDependents: IdsDependents[];
      dsPolicy: IdsPolicy;
      dsPolicyBenefitYear: IdsPolicyBenefitYear;
    };

    state = {
      effectiveDate: null,
      isFlex: false,
      options: [],
      selectedOption: null,
      creditCalcMethod: null,
      selectedWaitingPeriod: waitingPeriodMonths[0],
      selectedTeladocWaitingPeriod: TeladocWaitingPeriodMonths[0],
      isEligibleForCurrenYear: false,
      showReinstateModal: false,
      existingEmployeeId: null,
      showDuplicateEmailModal: false,
      isBelongToCurrentPolicy: false,
      showDivison: false,
      showCentres: false,
      showStartDateModal: false,
      showStartDateInput: false,
      employeeStartDate: null,
      overrideEmployeeStartDate: null,
      disableFlexEmails: false,
      computedPaApprovedBenefitStartDate: null,
      flexInfoVisible: false,
      noFlexDatesInfoVisible: false,
      isStartDateAdjusted: false
    };

    render() {
      let startDateInput = null;
      if (this.state.showStartDateInput) {
        startDateInput = (
          <div className="RT-TextBox__container">
            <div>
              <div style={{ paddingBottom: 10 }}>PA Approved Benefit Start Date</div>
              <div>
                <input
                  value={this.state.overrideEmployeeStartDate}
                  onChange={(e) => {
                    this.setState({
                      overrideEmployeeStartDate: e.target.value,
                    });
                  }}
                  className="form-control"
                  type="date"
                />
              </div>
            </div>
          </div>
        );
      }

      if (this.state.showStartDateModal) {
        var waitingPeriodMonthsLabel =
          this.state.employeeStartDate.waitingPeriodMonths &&
          this.state.employeeStartDate.waitingPeriodMonths > 1
            ? this.state.employeeStartDate.waitingPeriodMonths + " months"
            : this.state.employeeStartDate.waitingPeriodMonths + " month";
      }
      //   return (
      //     <Modal
      //       className="react-modal"
      //       show={this.state.showStartDateModal}
      //       backdrop="static"
      //       keyboard={false}
      //     >
      //       <Modal.Header className="react-modal-title">
      //         <Modal.Title>Add Employee (Step 2)</Modal.Title>
      //       </Modal.Header>
      //       <Modal.Body>
      //         <div className="RT-Section">
      //           <div className="RT-Line">
      //             <div className="RT-Line__content RT-Line__content--space-evenly">
      //               <div className="RT-Line__item">
      //                 <div className="RT-TextBox">
      //                   <label>Hire Date</label>
      //                   <div className="RT-TextBox__container">
      //                     <ReactMoment format="YYYY-MM-DD">
      //                       {this.state.employeeStartDate.hireDate}
      //                     </ReactMoment>
      //                   </div>
      //                 </div>
      //               </div>
      //               <div className="RT-Line__item">
      //                 <div className="RT-TextBox">
      //                   <label>Waiting Period</label>
      //                   <div className="RT-TextBox__container">
      //                     {waitingPeriodMonthsLabel}
      //                   </div>
      //                 </div>
      //               </div>
      //             </div>
      //           </div>
      //         </div>

      //         <div className="RT-Section">
      //           <div className="RT-Line">
      //             <div className="RT-Line__content RT-Line__content--space-evenly">
      //               <div className="RT-Line__item">
      //                 <div className="RT-TextBox">
      //                   <label>
      //                     Based on the Hire Date and Waiting Period you entered,
      //                     the system has calculated the Benefit Start Date as:
      //                   </label>
      //                   <div className="RT-TextBox__container">
      //                     <ReactMoment format="YYYY-MM-DD">
      //                       {this.state.employeeStartDate.startDate}
      //                     </ReactMoment>
      //                   </div>
      //                 </div>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         <div className="RT-Section">
      //           <div className="RT-Line">
      //             <div className="RT-Line__content RT-Line__content--space-evenly">
      //               <div className="RT-Line__item">
      //                 <div className="RT-TextBox">
      //                   <label>
      //                     If you wish to over-ride the system calculated start
      //                     date for this employee, please click the check box
      //                     and enter in your desired start date.
      //                   </label>
      //                 </div>
      //               </div>
      //               <div className="RT-Line__item">
      //                 <div className="RT-TextBox">
      //                   <div className="form-check" style={{ paddingLeft: 0 }}>
      //                     <label>
      //                       <input
      //                         type="checkbox"
      //                         checked={this.state.showStartDateInput}
      //                         onChange={() => this.toggleStartDateInput()}
      //                         style={{ paddingLeft: 0, marginRight: 10 }}
      //                       />
      //                       Override Employee Start Date
      //                     </label>
      //                   </div>
      //                   {startDateInput}
      //                 </div>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //       </Modal.Body>
      //       <Modal.Footer>
      //         <ReactButton
      //           variant="primary"
      //           onClick={() => this.finishEmployeeAdd()}
      //         >
      //           Finish Employee Add
      //         </ReactButton>
      //       </Modal.Footer>
      //     </Modal>
      //   );
      // }
      return renderScreen(this);
    }

    finishEmployeeAdd = async () => {
      await this.submit({ screen: this.screen } as any);
    };

    async openStartDateModal({}: ActionEvent) {
      this.setState({ showStartDateModal: true });
    }

    closeStartDateModal = () => {
      this.setState({ showStartDateModal: false });
    };

    toggleStartDateInput = () => {
      this.setState({ showStartDateInput: !this.state.showStartDateInput });
    };

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsEmployee";
      await KTMApi.start(screen, {
        "@policy_id": this.props.policy_id,
      });
      screen.title = "Add employee";
      screen.setOnValueChanged(
        "@dsDependents.FirstName",
        this.DependentFirstName_onchange
      );
      this.screen = screen;
      await this.getEffectiveDate();
      await this.getBenefitCategories();
      await this.fetchDivisionsData();
      await this.fetchCostCentresData();
      screen.setOnValueChanged("@dsEmployee.Email", this.checkIfEmployeeExists);
      screen.setOnValueChanged(
        "@dsEmployee.PaApprovedBenefitStartDate",
        this.onPaApprovedStartChanged
      );
      screen.setOnValueChanged("@dsEmployee.HireDate", this.onHireDateChanged);
    }

    async getEffectiveDate() {
      let response = await fetch(
        "/api/Employees/geteffectivedate?policyId=" + this.data.dsPolicy.Id
      );
      let planEffectiveDate = await response.json();
      this.setState({ effectiveDate: planEffectiveDate.date });
    }

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout dialogSize="medium">
          {draw(this.header)}
          {draw(this.main_tab)}
          {draw(this.footer)}
          {this.state.showReinstateModal && draw(this.reinstateModal)}
          {this.state.showDuplicateEmailModal && draw(this.duplicateEmailModal)}
        </Layout>
      );
    }

    header({ field, draw, action }: RenderEvent) {
      return <Dialog.Header label="Add Employee" />;
    }

    footer({ field, draw, action }: RenderEvent) {
      var isDisabled =
        this.data.dsEmployee.FirstName === null ||
        this.data.dsEmployee.FirstName === undefined ||
        this.data.dsEmployee.FirstName === "" ||
        this.data.dsEmployee.LastName === null ||
        this.data.dsEmployee.LastName === undefined ||
        this.data.dsEmployee.LastName === "" ||
        this.data.dsEmployee.Email === null ||
        this.data.dsEmployee.Email === undefined ||
        this.data.dsEmployee.Email === "" ||
        this.data.dsEmployee.DateOfBirth === null ||
        this.data.dsEmployee.DateOfBirth === undefined ||
        this.data.dsEmployee.DateOfBirth === "" ||
        this.data.dsEmployee.WaitingPeriodMonths === null ||
        this.data.dsEmployee.WaitingPeriodMonths === undefined ||
        this.data.dsEmployee.BenefitCategory_Id === null ||
        this.data.dsEmployee.BenefitCategory_Id === undefined ||
        this.state.existingEmployeeId !== null
          ? true
          : false;

      if (
        !isDisabled &&
        Array.isArray(this.data.dsDependents) &&
        this.data.dsDependents.length > 0
      ) {
        const partiallyFilledDependentExists = this.data.dsDependents.some(
          (dependent) => {
            const fields = [
              dependent.FirstName,
              dependent.LastName,
              dependent.DateOfBirth,
              dependent.Relation,
            ];
            const filledFields = fields.filter(Boolean).length;
            return filledFields > 0 && filledFields < fields.length;
          }
        );

        if (partiallyFilledDependentExists) {
          isDisabled = true;
        }
      }

      return (
        <Dialog.Footer>
          <Button
            action={
              // this.state.isFlex
              //   ? action(this.openStartDateModal) :
              action(this.submit)
            }
            label="Save"
            size="large"
            style="primary"
            disable={isDisabled}
          />
        </Dialog.Footer>
      );
    }

    dependents_table({ field, draw, action }: RenderEvent) {
      return (
        <table className="RT-Table">
          <thead>
            <tr className="RT-Table__tr">
              <th className="RT-Table__th RT-Table__th--align-left">
                First name
              </th>
              <th className="RT-Table__th RT-Table__th--align-left">
                Last name
              </th>
              <th className="RT-Table__th RT-Table__th--align-left">
                Date of birth
              </th>
              <th className="RT-Table__th RT-Table__th--align-left">
                Relation
              </th>
            </tr>
          </thead>
          <tbody>{draw(this.dependent_row, { each: "@dsDependents" })}</tbody>
        </table>
      );
    }

    dependent_row({ field }: RenderEvent) {
      return (
        <tr className="RT-Table__tr">
          <td className="RT-Table__td RT-Table__td--align-left">
            <Display
              field={field("@dsDependents.FirstName")}
              hideLabel={true}
            />
          </td>
          <td className="RT-Table__td RT-Table__td--align-left">
            <Display field={field("@dsDependents.LastName")} hideLabel={true} />
          </td>
          <td className="RT-Table__td RT-Table__td--align-left">
            <Display
              field={field("@dsDependents.DateOfBirth")}
              hideLabel={true}
            />
          </td>
          <td className="RT-Table__td RT-Table__td--align-left">
            <Display field={field("@dsDependents.Relation")} hideLabel={true} />
          </td>
        </tr>
      );
    }

    general({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Line>
            <Display required field={field("FirstName")} />
            <Display required field={field("LastName")} />
            <Display field={field("Nickname")} />
            <Display field={field("MaidenName")} />
          </Line>
          <Line>
            <Display required field={field("Email")} span="6" />
            <Display required field={field("DateOfBirth")} />
            <Display field={field("EmployeeNo")} />
          </Line>
        </Card>
      );
    }

    hire_date({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Line>
            <InfoBox>
              The Hire Date is defaulted to the Plan Effective Date, but
              over-ride this date as needed per employee. Once the Waiting
              Period option is chosen, the employee’s <b>PA Approved Benefit Start
              Date (below)</b> will appear, which is the date the employee actually
              becomes eligible, and is the earliest date they receive their
              first Welcome email with login instructions.
              <br />
              <br />
              If the Pro-rate option applies, it will use the PA Approved
              Benefit Start Date for benefit calculations.
            </InfoBox>
          </Line>
          <Line>
            <Display
              required
              field={field("HireDate")}
              defaultValue={
                this.state.effectiveDate != null ? this.state.effectiveDate : ""
              }
              span="6"
            />
          </Line>
        </Card>
      );
    }

    teladoc_waiting_period({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Line>
            <div
              className="RT-Line__content RT-Line__content--space-evenly"
              style={{ height: 60 }}
            >
              <div className="RT-Line__item" style={{ flexGrow: 0 }}>
                <div className="RT-TextBox add-employee-teladoc-waiting-period">
                  <label className="RT-Label">
                    Teladoc Waiting Period (months)
                  </label>
                  <CustomDropdown
                    options={TeladocWaitingPeriodMonths.map((option) => {
                      return option.label;
                    })}
                    selectedOption={
                      this.state.selectedTeladocWaitingPeriod.label
                    }
                    setSelectedOption={this.setSelectedTeladocWaitingPeriod}
                  />
                </div>
              </div>
            </div>
          </Line>
        </Card>
      );
    }

    category({ field, draw, action }: RenderEvent) {
      const { options, selectedOption, selectedWaitingPeriod } = this.state;
      return (
        <Card>
          <div className="RT-Line">
            <div
              className="RT-Line__content RT-Line__content--space-evenly"
              style={{ marginBottom: 20 }}
            >
              <div
                className="RT-Line__item"
                style={{ height: 50, flexGrow: 0 }}
              >
                <div className="RT-TextBox add-employee-ben-cat">
                  <label className="RT-Label">
                    <span className="text-danger">*</span>
                    Benefit Category
                  </label>
                  <CustomDropdown
                    options={options.map((option) => {
                      return option.name;
                    })}
                    selectedOption={selectedOption.name}
                    setSelectedOption={this.setSelectedOption}
                  />
                </div>
              </div>
              <div className="RT-Line__item" style={{ flexGrow: 0 }}>
                <div className="RT-TextBox add-employee-waiting-period">
                  <label className="RT-Label">
                    <span className="text-danger">*</span>
                    Waiting Period (months)
                    <CustomToolTip
                      header="Waiting Period (months)"
                      bodyContent="Choose how long an employee waits after being hired for their benefits to start. "
                    />
                  </label>
                  <CustomDropdown
                    options={waitingPeriodMonths.map((option) => {
                      return option.label;
                    })}
                    selectedOption={selectedWaitingPeriod.label}
                    setSelectedOption={this.setSelectedWaitingPeriod}
                  />
                </div>
              </div>

              {selectedOption && !selectedOption.hasAccrual ? (
                <div style={{ marginLeft: 30, marginTop: 35 }}>
                  <Display
                    field={field("HasProrating")}
                    toolTip={
                      <CustomToolTip
                        header="Pro-rating"
                        bodyContent="Proration is calculated per month, inclusive of the month employees become eligible within. If left unchecked, an employee receives their full yearly category limit."
                      />
                    }
                  />
                </div>
              ) : null}
            </div>
          </div>
          {selectedOption && selectedOption.hasAccrual ? (
            <Line>
              <InfoBox>
                <b>Category chosen has Scheduled Credits.</b> Employee’s yearly credits
                will be earned incrementally based on the policy’s Frequency.
                The employee’s total benefit calculation for their first year is
                based on their PA Approved Benefit Start Date. If this date
                falls within an increment period, then that increment amount is
                included in full as part of their total benefit calculation.
              </InfoBox>
            </Line>
          ) : null}
          <Line>
            <Display
              required
              field={field("PaApprovedBenefitStartDate")}
              span="6"
              toolTip={
                <CustomToolTip
                  header="PA Approved Benefit Start Date"
                  bodyContent="The date employees become eligible, based on Hire Date and Waiting Period selection."
                />
              }
            />
          </Line>
        </Card>
      );
    }

    main_tab({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>
            {draw(this.general)}
            {this.state.showCentres || this.state.showDivison
              ? draw(this.reporting)
              : null}
            {draw(this.hire_date)}
            {/*{this.data.dsPolicy.HasTeladoc && draw(this.teladoc_waiting_period)}*/}
            {draw(this.category)}
            {this.state.isFlex ? draw(this.flex) : null}
            {this.state.creditCalcMethod === "SALARY"
              ? draw(this.salaryInput)
              : null}
            {draw(this.dependents)}
          </Column>
        </Panel>
      );
    }

    reporting({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Line>
            {this.state.showDivison ? (
              <Display field={field("Division_Id")} />
            ) : (
              <></>
            )}
            {this.state.showCentres ? (
              <Display field={field("CostCentre_Id")} />
            ) : (
              <></>
            )}
          </Line>
        </Card>
      );
    }

    flex({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          {this.state.flexInfoVisible && this.state.isEligibleForCurrenYear && (
            <div style={{ marginBottom: "10px" }}>
              <span
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <span style={{ fontWeight: "bold" }}>
                  What are these dates?
                </span>
                <CustomToolTip
                  header="What are these dates?"
                  bodyContent={
                    <>
                      <p>
                        Flex Selection emails will be sent to the employee
                        starting on the Launch date below, with two reminder
                        emails to follow. If no selections are made before the
                        Deadline, their allocations will default according to
                        the policy’s chosen category default split.
                      </p>
                      <p>
                        Employees receive their initial Welcome email with login
                        instructions the day after they have either made their
                        Flex selection or defaulted after the Deadline. If their
                        PA Approved Benefit Start Date has not yet passed at the
                        time of selection, they will not receive the Welcome
                        email until it is reached.
                      </p>
                    </>
                  }
                >
                  <i
                    className="fa fa-info-circle"
                    style={{ cursor: "pointer", color: "#007bff" }}
                  />
                </CustomToolTip>
              </span>
              <InfoBox>
                <p>
                  The auto-populated Flex Selection dates below are suggested
                  based on the PA Approved Benefit Start Date. Please change
                  these dates as needed. However, any changes to the PA Approved
                  Benefit Start Date above will cause these dates to
                  recalculate.
                </p>
              </InfoBox>
            </div>
          )}
          {this.state.noFlexDatesInfoVisible && (
            <Line>
              <InfoBox>
                <p>
                  The PA Approved Benefit Start Date for this employee falls
                  into the next benefit year. Flex Selections for their first
                  eligible benefit year will be automated through the next
                  year-end Flex Campaign. Flex Selection Dates are not required
                  in this step.
                </p>
              </InfoBox>
            </Line>
          )}

          {this.state.flexInfoVisible && this.state.isEligibleForCurrenYear && (
            <Line>
              <Display
                field={field("FlexLaunchDate")}
                toolTip={
                  <CustomToolTip
                    header="Flex Launch Date"
                    bodyContent="The date the employee will receive their first Flex Selection email."
                  />
                }
              />
              <Display
                field={field("FlexReminderDate")}
                toolTip={
                  <CustomToolTip
                    header="Flex Reminder Date"
                    bodyContent="The date the employee will receive their first Reminder email if they have not yet made a selection."
                  />
                }
              />
            </Line>
          )}
          {this.state.flexInfoVisible && this.state.isEligibleForCurrenYear && (
            <Line>
              <Display
                field={field("FlexLastDayReminderDate")}
                toolTip={
                  <CustomToolTip
                    header="Flex Last Day Reminder Date"
                    bodyContent="The date the employee will receive their last Reminder email if they have not yet made a selection."
                  />
                }
              />
              <Display
                field={field("FlexSelectionDeadline")}
                toolTip={
                  <CustomToolTip
                    header="Flex Selection Deadline"
                    bodyContent="The last day that the employee is able to make their selection. 
                    After this date they will default to the policy’s chosen Default split, 
                    which can be found in the assigned benefit category details."
                  />
                }
              />
            </Line>
          )}
        </Card>
      );
    }

    salaryInput({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Line>
            <Display field={field("SalaryMoney")} />
          </Line>
        </Card>
      );
    }

    dependents({ field, draw, action }: RenderEvent) {
      return (
        <Card label="Dependents">
          {draw(this.dependents_table)}
          <Button
            action={action(this.add_child)}
            label="Add child"
            style="link"
          />
        </Card>
      );
    }

    reinstateModal({ draw, action }: RenderEvent) {
      const { showReinstateModal, isBelongToCurrentPolicy } = this.state;

      return (
        <Modal
          show={showReinstateModal}
          centered
          style={{ top: 200, zIndex: 9999 }}
          aria-label="Reinstate Modal"
        >
          <Modal.Header>
            <Modal.Title style={{ fontSize: "17px" }}>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card>
              This address is associated with a previously terminated employee.
              Please update the terminated account first to avoid duplication.
              <br />
              To reinstate the terminated account instead of proceeding, click
              'Reinstate Employee' to open the terminated profile in a new tab,
              and reinstate the employee under 'Terminations'.
              <br />
              Reinstating is effective immediately, so remember to adjust their
              Waiting Period, Prorate Limit, and PA Approved Benefit Start Date
              under their 'Benefit Limits' tab if necessary.
              <br />
              If more assistance is required, please don't hesitate to contact{" "}
              <a
                href="mailto:support@nationalhealthclaim.com"
                style={{ color: "#0d6efd" }}
              >
                {" "}
                support@nationalhealthclaim.com
              </a>
              .
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button
              label="Close"
              style="cancel"
              action={action(this.close_reinstate_modal)}
            />
            {isBelongToCurrentPolicy && (
              <Button
                label="Reinstate Employee"
                style="primary"
                action={action(this.view_existing_employee)}
              />
            )}
          </Modal.Footer>
        </Modal>
      );
    }

    duplicateEmailModal({ draw, action }: RenderEvent) {
      const { showDuplicateEmailModal, isBelongToCurrentPolicy } = this.state;

      return (
        <Modal
          show={showDuplicateEmailModal}
          centered
          style={{ top: 200, zIndex: 9999 }}
          aria-label="Duplicate Email Modal"
        >
          <Modal.Header>
            <Modal.Title style={{ fontSize: "17px" }}>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card>
              The email address you entered is already associated with an
              existing employee. If you need further assistance, please don't
              hesitate to contact
              <a
                href="mailto:support@nationalhealthclaim.com"
                style={{ color: "#0d6efd" }}
              >
                {" "}
                support@nationalhealthclaim.com
              </a>
              .
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button
              label="Close"
              style="cancel"
              action={action(this.close_duplicate_email_modal)}
            />
            {isBelongToCurrentPolicy && (
              <Button
                label="Check Employee"
                style="primary"
                action={action(this.view_existing_employee)}
              />
            )}
          </Modal.Footer>
        </Modal>
      );
    }

    async close_duplicate_email_modal({ screen }: ActionEvent) {
      this.setState({
        showDuplicateEmailModal: false,
      });
    }

    async close_reinstate_modal({ screen }: ActionEvent) {
      this.setState({
        showReinstateModal: false,
      });
    }

    async view_existing_employee({ screen }: ActionEvent) {
      window.open(
        `/ops/planadmin.employee.record?employee_id=${this.state.existingEmployeeId}`,
        "_blank"
      );
    }

    async submit({ screen }: ActionEvent) {
      let dependents = {
        $type: "dataset",
        name: "@dsDependents",
        rows: this.data.dsDependents,
      };

      if (
        this.data.dsEmployee.HireDate == null ||
        this.data.dsEmployee.HireDate == "" ||
        this.data.dsEmployee.HireDate == undefined
      ) {
        this.data.dsEmployee.HireDate = this.state.effectiveDate;
      }

      if (
        this.data.dsEmployee.SalaryMoney == null ||
        this.data.dsEmployee.SalaryMoney == undefined
      ) {
        this.data.dsEmployee.SalaryMoney = 0;
      }

      if (this.state.isFlex && this.state.isEligibleForCurrenYear) {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        const futureDate = moment(date).format("YYYY-MM-DD");

        const {
          FlexLaunchDate,
          FlexReminderDate,
          FlexLastDayReminderDate,
          FlexSelectionDeadline,
        } = this.data.dsEmployee;

        if (
          moment(FlexLaunchDate).isSameOrAfter(
            moment(this.data.dsPolicyBenefitYear.EndDate)
          )
        ) {
          toastr.error(
            "Flex Launch Date should be before the current benefit year end date."
          );
          return;
        }
        if (moment(FlexLaunchDate).isBefore(futureDate)) {
          toastr.error("Flex Launch Date should be greater than today's date");
          return;
        }
        if (moment(FlexLaunchDate).isAfter(FlexReminderDate)) {
          toastr.error(
            "Flex Launch Date should be less than Flex Reminder Date"
          );
          return;
        }
        if (moment(FlexLaunchDate).isAfter(FlexLastDayReminderDate)) {
          toastr.error(
            "Flex Launch Date should be less than Flex Last Day Reminder Date"
          );
          return;
        }
        if (moment(FlexLaunchDate).isAfter(FlexSelectionDeadline)) {
          toastr.error(
            "Flex Launch Date should be less than Flex Selection Deadline"
          );
          return;
        }
        if (moment(FlexReminderDate).isSame(FlexLaunchDate)) {
          toastr.error(
            "Flex Reminder Date should not be same as Flex Launch Date"
          );
          return;
        }
        if (moment(FlexReminderDate).isAfter(FlexLastDayReminderDate)) {
          toastr.error(
            "Flex Reminder Date should be less than Flex Last Day Reminder Date"
          );
          return;
        }
        if (moment(FlexReminderDate).isAfter(FlexSelectionDeadline)) {
          toastr.error(
            "Flex Reminder Date should be less than Flex Selection Deadline"
          );
          return;
        }
        if (moment(FlexReminderDate).isSame(FlexLastDayReminderDate)) {
          toastr.error(
            "Flex Reminder Date should not be same as Flex Last Day Reminder Date"
          );
          return;
        }
        if (moment(FlexLastDayReminderDate).isBefore(FlexLaunchDate)) {
          toastr.error(
            "Flex Last Day Reminder Date should be greater than Flex Launch Date"
          );
          return;
        }
        if (moment(FlexLastDayReminderDate).isSame(FlexLaunchDate)) {
          toastr.error(
            "Flex Last Day Reminder Date should not be same as Flex Launch Date"
          );
          return;
        }
        if (moment(FlexLastDayReminderDate).isAfter(FlexSelectionDeadline)) {
          toastr.error(
            "Flex Last Day Reminder Date should be less than Flex Selection Deadline"
          );
          return;
        }
        if (
          moment(FlexSelectionDeadline).isSame(
            moment(this.data.dsPolicyBenefitYear.EndDate)
          )
        ) {
          toastr.error(
            "Flex Selection Deadline should not be same as the benefit end date."
          );
          return;
        }

        if (
          this.data.dsEmployee.SalaryMoney != null &&
          this.data.dsEmployee.SalaryMoney != undefined
        ) {
          this.data.dsEmployee.SalaryMoney = Math.round(
            this.data.dsEmployee.SalaryMoney
          );
        }
      }
      if (
        this.data.dsEmployee.TeladocWaitingPeriodMonths == null ||
        this.data.dsEmployee.TeladocWaitingPeriodMonths == undefined
      ) {
        this.data.dsEmployee.TeladocWaitingPeriodMonths = 0;
      }

      const policyLogs = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Note:
            "Employee FirstName: " +
            this.data.dsEmployee.FirstName +
            " LastName: " +
            this.data.dsEmployee.LastName +
            " Email: " +
            this.data.dsEmployee.Email,
          Action: "Policy Add New Employee",
          PolicyId: this.props.policy_id,
        }),
      };

      this.data.dsEmployee.IsStartDateAdjusted = this.state.isStartDateAdjusted;
      if (this.data.dsPolicy.IsActive) {
        await KTMApi.action(screen, "submitandgenerate", {
          "@policy_id": this.props.policy_id,
          "@dsDependents:all_rows": dependents,
          "@dsEmployee.FirstName": this.data.dsEmployee.FirstName,
          "@dsEmployee.LastName": this.data.dsEmployee.LastName,
          "@dsEmployee.Email": this.data.dsEmployee.Email,
          "@dsEmployee.MaidenName": this.data.dsEmployee.MaidenName,
          "@dsEmployee.Nickname": this.data.dsEmployee.Nickname,
          "@dsEmployee.DateOfBirth": this.data.dsEmployee.DateOfBirth,
          "@dsEmployee.HireDate": this.data.dsEmployee.HireDate,
          "@dsEmployee.PaApprovedBenefitStartDate": this.data.dsEmployee.PaApprovedBenefitStartDate,
          "@dsEmployee.IsStartDateAdjusted" : this.data.dsEmployee.IsStartDateAdjusted,
          "@dsEmployee.EmployeeNo": this.data.dsEmployee.EmployeeNo,
          "@dsEmployee.BenefitCategory_Id":
            this.data.dsEmployee.BenefitCategory_Id,
          "@dsEmployee.WaitingPeriodMonths":
            this.data.dsEmployee.WaitingPeriodMonths,
          "@dsEmployee.HasProrating": this.data.dsEmployee.HasProrating,
          "@dsEmployee.FlexLaunchDate": this.data.dsEmployee.FlexLaunchDate,
          "@dsEmployee.FlexSelectionDeadline":
            this.data.dsEmployee.FlexSelectionDeadline,
          "@dsEmployee.FlexReminderDate": this.data.dsEmployee.FlexReminderDate,
          "@dsEmployee.FlexLastDayReminderDate":
            this.data.dsEmployee.FlexLastDayReminderDate,
          "@dsEmployee.SalaryMoney": this.data.dsEmployee.SalaryMoney,
          "@dsEmployee.TeladocWaitingPeriodMonths":
            this.data.dsEmployee.TeladocWaitingPeriodMonths,
        }).then(() => {
          fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
      } else {
        await KTMApi.action(screen, "submit", {
          "@policy_id": this.props.policy_id,
          "@dsDependents:all_rows": dependents,
          "@dsEmployee.FirstName": this.data.dsEmployee.FirstName,
          "@dsEmployee.LastName": this.data.dsEmployee.LastName,
          "@dsEmployee.Email": this.data.dsEmployee.Email,
          "@dsEmployee.MaidenName": this.data.dsEmployee.MaidenName,
          "@dsEmployee.Nickname": this.data.dsEmployee.Nickname,
          "@dsEmployee.DateOfBirth": this.data.dsEmployee.DateOfBirth,
          "@dsEmployee.HireDate": this.data.dsEmployee.HireDate,
          "@dsEmployee.PaApprovedBenefitStartDate": this.data.dsEmployee.PaApprovedBenefitStartDate,
          "@dsEmployee.IsStartDateAdjusted" : this.data.dsEmployee.IsStartDateAdjusted,
          "@dsEmployee.EmployeeNo": this.data.dsEmployee.EmployeeNo,
          "@dsEmployee.BenefitCategory_Id":
            this.data.dsEmployee.BenefitCategory_Id,
          "@dsEmployee.WaitingPeriodMonths":
            this.data.dsEmployee.WaitingPeriodMonths,
          "@dsEmployee.HasProrating": this.data.dsEmployee.HasProrating,
          "@dsEmployee.FlexLaunchDate": this.data.dsEmployee.FlexLaunchDate,
          "@dsEmployee.FlexSelectionDeadline":
            this.data.dsEmployee.FlexSelectionDeadline,
          "@dsEmployee.FlexReminderDate": this.data.dsEmployee.FlexReminderDate,
          "@dsEmployee.FlexLastDayReminderDate":
            this.data.dsEmployee.FlexLastDayReminderDate,
          "@dsEmployee.SalaryMoney": this.data.dsEmployee.SalaryMoney,
          "@dsEmployee.TeladocWaitingPeriodMonths":
            this.data.dsEmployee.TeladocWaitingPeriodMonths,
        }).then(() => {
          fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
      }

      await screen.restart();
      //this.closeStartDateModal();
      await screen.close({ continue: true });
    }

    setSelectedOption = (selectedOption: any) => {
      var findOption = this.state.options.find(
        (option) => option.name == selectedOption
      );
      this.setState({ selectedOption: findOption });
      this.data.dsEmployee.BenefitCategory_Id = findOption.id;
      this.check_ben_cat_type();
      this.check_benefit_start_date();
    };

    setSelectedWaitingPeriod = (selectedWaitingPeriod: any) => {
      var findOption = waitingPeriodMonths.find(
        (option) => option.label == selectedWaitingPeriod
      );
      this.setState({ selectedWaitingPeriod: findOption });
      this.data.dsEmployee.WaitingPeriodMonths = findOption.value;
      this.check_benefit_start_date();
    };

    setSelectedTeladocWaitingPeriod = (selectedTeladocWaitingPeriod: any) => {
      var findOption = TeladocWaitingPeriodMonths.find(
        (option) => option.label == selectedTeladocWaitingPeriod
      );
      this.setState({ selectedTeladocWaitingPeriod: findOption });
      this.data.dsEmployee.TeladocWaitingPeriodMonths = findOption.value;
      this.check_benefit_start_date();
    };

    async getBenefitCategories() {
      let response = await fetch(
        "/api/Employees/getbenefitcategories?policyId=" + this.props.policy_id
      );
      let res = await response.json();
      var options = [
        { Id: null, name: "--Select--", hasAccrual: false },
        ...res,
      ];
      this.setState({
        options: options,
        selectedOption: options[0],
      });
    }

    async check_ben_cat_type() {
      if (
        this.data.dsEmployee.BenefitCategory_Id == null ||
        this.data.dsEmployee.BenefitCategory_Id == undefined
      ) {
        this.setState({
          isFlex: false,
          creditCalcMethod: null,
        });
        return;
      }

      let response = await fetch(
        "/api/Employees/checkbencattype?policyId=" +
          this.props.policy_id +
          "&bencatId=" +
          this.data.dsEmployee.BenefitCategory_Id
      );
      let res = await response.json();

      if (res.success) {
        this.setState({
          isFlex: res.benCat.isFlex,
          creditCalcMethod: res.benCat.creditCalcMethod,
        });
      } else {
        this.setState({
          isFlex: false,
          creditCalcMethod: null,
        });
      }
    }

    async add_child({ screen }: ActionEvent) {
      screen.addRow("@dsDependents");
      screen.setValue("@dsDependents.Relation", "CHILD");
      screen.focus("@dsDependents.FirstName");
    }

    async remove_child({ screen }: ActionEvent) {
      screen.removeRow("@dsDependents");
    }

    async DependentFirstName_onchange({ screen }: ActionEvent) {
      let lastName = screen.getValue("@dsDependents.LastName");
      if (!lastName) {
        screen.setValue("@dsDependents.LastName", screen.getValue("LastName"));
      }
    }

    async check_benefit_start_date(fromUserEdit: boolean = false) {
      const rawWait = this.data?.dsEmployee?.WaitingPeriodMonths;
      if ((rawWait == null || rawWait == undefined) && !fromUserEdit) return;
      const waitMonths = rawWait ?? 0;
      let hireDate: string =
        this.data?.dsEmployee?.HireDate || this.state.effectiveDate || "";

      try {
        const resp = await fetch(
          "/api/Employees/checkbenefitstartdate?policyId=" +
            this.props.policy_id +
            "&waitingPeriodMonths=" +
            waitMonths +
            "&hireDate=" +
            hireDate
        );
        const res = await resp.json();

        if (res?.success) {
          this.setState({
            isEligibleForCurrenYear: res.isEligibleForCurrenYear,
          });

          const baselineISO = this.computeBaseline(hireDate, waitMonths);
          if (
            baselineISO ===
            this.screen.getValue("@dsEmployee.PaApprovedBenefitStartDate")
          )
            this.setState({ isStartDateAdjusted: false });
          else this.setState({ isStartDateAdjusted: true });
          this.setState({ baselineApprovedStart: baselineISO });

          const apiApproved: string | null =
            res.approvedStartDate ||
            res.benefitStartDate ||
            res.startDate ||
            null;

          let approvedStartISO: string | null;
          if (fromUserEdit) {
            approvedStartISO =
              this.screen.getValue("@dsEmployee.PaApprovedBenefitStartDate") ||
              this.data?.dsEmployee?.PaApprovedBenefitStartDate ||
              null;
          } else {
            approvedStartISO = apiApproved || baselineISO;
            // Only set the field when NOT coming from a user edit
            this.screen.setValue(
              "@dsEmployee.PaApprovedBenefitStartDate",
              approvedStartISO
            );
          }

          // If no approved date (edge case), clear and bail
          if (!approvedStartISO) {
            this.clearFlexDates();
            this.setState({
              flexInfoVisible: false,
              noFlexDatesInfoVisible: false,
            });
            return;
          }

          // If approved start is in NEXT benefit year: no flex dates
          if (this.isInNextBenefitYear(approvedStartISO)) {
            this.clearFlexDates();
            this.setState({
              flexInfoVisible: false,
              noFlexDatesInfoVisible: true,
            });
            return;
          }

          // Compute flex dates when applicable
          if (this.state.isFlex && this.state.isEligibleForCurrenYear) {
            this.computeAndSetFlexDates(approvedStartISO);
            this.setState({
              flexInfoVisible: true,
              noFlexDatesInfoVisible: false,
            });
          } else {
            this.clearFlexDates();
            this.setState({
              flexInfoVisible: false,
              noFlexDatesInfoVisible: false,
            });
          }
        } else {
          this.clearFlexDates();
          this.setState({
            flexInfoVisible: false,
            noFlexDatesInfoVisible: false,
          });
        }
      } catch (e) {
        this.clearFlexDates();
        this.setState({ flexInfoVisible: false });
      }
    }

    private computeBaseline(hireDate: string, waitMonths: number): string {
      const hd = moment(
        hireDate,
        ["YYYY-MM-DD", moment.ISO_8601, "M/D/YYYY"],
        true
      );
      const base = (hd.isValid() ? hd : moment(hireDate))
        .clone()
        .add(waitMonths || 0, "months")
        .format("YYYY-MM-DD");
      return base;
    }

    private isInNextBenefitYear(approvedStartISO: string): boolean {
      const benefitEndRaw = this.data?.dsPolicyBenefitYear?.EndDate;
      if (!benefitEndRaw) return false;

      const approved = moment(
        approvedStartISO,
        ["YYYY-MM-DD", moment.ISO_8601, "M/D/YYYY"],
        true
      );
      const benefitEnd = moment(
        benefitEndRaw,
        ["YYYY-MM-DD", moment.ISO_8601, "M/D/YYYY"],
        true
      );

      if (!approved.isValid() || !benefitEnd.isValid()) return false;
      return approved.isAfter(benefitEnd, "day");
    }

    private formatYMD = (d: moment.Moment) => d.format("YYYY-MM-DD");

    private clearFlexDates() {
      if (!this.screen) return;
      this.screen.setValue("@dsEmployee.FlexLaunchDate", null);
      this.screen.setValue("@dsEmployee.FlexReminderDate", null);
      this.screen.setValue("@dsEmployee.FlexLastDayReminderDate", null);
      this.screen.setValue("@dsEmployee.FlexSelectionDeadline", null);
    }

    private computeAndSetFlexDates = (approvedStartDateISO: string) => {
      if (!approvedStartDateISO) {
        this.clearFlexDates();
        return;
      }

      const by = this.data.dsPolicyBenefitYear;
      const approvedStart = moment(approvedStartDateISO, "YYYY-MM-DD");
      const byEnd = moment(by?.EndDate, "YYYY-MM-DD").endOf("day");

      // Rule: If approved start date falls in the NEXT benefit year => set/require NO dates.
      if (by && approvedStart.isAfter(byEnd)) {
        this.clearFlexDates();
        return;
      }

      const today = moment().startOf("day");
      const tomorrow = moment(today).add(1, "day");

      // Base “normal” plan:
      // Deadline = day before approved start date
      const normalDeadline = moment(approvedStart).subtract(1, "day");
      const normalLaunch = moment(normalDeadline).subtract(14, "day");
      const normalReminder1 = moment(normalDeadline).subtract(7, "day");
      const normalReminder2 = moment(normalDeadline).subtract(1, "day");

      // Is there >= 14 days before approved start? (i.e., approvedStart - today >= 14 days)
      const hasTwoWeeksLead = approvedStart.diff(today, "days") >= 14;

      if (hasTwoWeeksLead) {
        this.setFlexDates(
          this.formatYMD(normalLaunch),
          this.formatYMD(normalReminder1),
          this.formatYMD(normalReminder2),
          this.formatYMD(normalDeadline)
        );
      } else {
        // Last-minute / retroactive:
        // Launch = day after today
        const launch = moment(tomorrow);
        // Deadline = 2 weeks after Launch
        const deadline = moment(launch).add(14, "day");
        // 1st reminder = one week from today
        const reminder1 = moment(today).add(7, "day");
        // 2nd reminder = day before deadline
        const reminder2 = moment(deadline).subtract(1, "day");
        this.setFlexDates(
          this.formatYMD(launch),
          this.formatYMD(reminder1),
          this.formatYMD(reminder2),
          this.formatYMD(deadline)
        );
      }
    };

    async onPaApprovedStartChanged({ screen }: ActionEvent) {
      const newPA = screen.getValue("@dsEmployee.PaApprovedBenefitStartDate");
      if (!newPA) {
        this.clearFlexDates();
        this.setState({
          flexInfoVisible: false,
          noFlexDatesInfoVisible: false,
        });
        return;
      }
      await this.check_benefit_start_date(true);
    }

    async onHireDateChanged({ screen }: ActionEvent) {
      await this.check_benefit_start_date();
    }

    private setFlexDates(
      launch: string,
      r1: string,
      r2: string,
      deadline: string
    ) {
      if (!this.screen) return;
      this.screen.setValue("@dsEmployee.FlexLaunchDate", launch);
      this.screen.setValue("@dsEmployee.FlexReminderDate", r1);
      this.screen.setValue("@dsEmployee.FlexLastDayReminderDate", r2);
      this.screen.setValue("@dsEmployee.FlexSelectionDeadline", deadline);
    }

    async checkIfEmployeeExists({ screen }: ActionEvent) {
      const email = screen.getValue("@dsEmployee.Email");
      if (!email) return;
      const encodedEmail = encodeURIComponent(email);
      let response = await fetch(
        `/api/Employees/checkifemployeeexists?email=${encodedEmail}` +
          "&policyId=" +
          this.props.policy_id
      );
      let res = await response.json();
      if (res.success) {
        this.setState({
          showReinstateModal: !res.isActive,
          existingEmployeeId: res.employeeId,
          showDuplicateEmailModal: res.isActive,
          isBelongToCurrentPolicy: res.isBelongToCurrentPolicy,
        });
      } else {
        this.setState({
          showReinstateModal: false,
          existingEmployeeId: null,
          showDuplicateEmailModal: false,
          isBelongToCurrentPolicy: false,
        });
      }
    }

    async get_employee_start_date() {
      let response = await fetch(
        "/api/PlanAdmin/getemployeestartdate?policyId=" + this.data.dsPolicy.Id
      );
      let emp = await response.json();
      this.setState({ employeeStartDate: emp });
    }

    update_employee_start_date = async () => {
      if (
        this.screen.getValue("@dsEmployee.PaApprovedBenefitStartDate") != null &&
        this.state.employeeStartDate.startDate != null &&
        this.state.employeeStartDate.startDate !=
          this.screen.getValue("@dsEmployee.PaApprovedBenefitStartDate")
      ) {
        const requestOptions = {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Id: this.state.employeeStartDate.id,
            BenefitStartDate: this.screen.getValue(
              "@dsEmployee.PaApprovedBenefitStartDate"
            ),
            IsStartDateAdjusted: true,
          }),
        };

        await fetch("/api/PlanAdmin/updatestartdate", requestOptions)
          .then((response) => response.json())
          .then((data) => {
            toastr.success("Employee created", "Success");
          })
          .catch((error) => {
            toastr.error("Failed to add employee", "Error");
          });
      } else {
        toastr.success("Employee created", "Success");
      }
      this.setState({
        showStartDateInput: false,
        overrideEmployeeStartDate: null,
      });
      this.closeStartDateModal();
    };

    async fetchDivisionsData() {
      try {
        let response = await fetch(
          `/api/PlanAdmin/divisions?policyId=${this.props.policy_id}`
        );
        let res = await response.json();
        if (res.success) {
          this.setState({
            showDivison: res.divisions.length > 0,
          });
        } else {
          toastr.error(res.message, "Error");
        }
      } catch (error) {
        toastr.error(error, "Error");
      }
    }

    async fetchCostCentresData() {
      try {
        let response = await fetch(
          `/api/PlanAdmin/costcentres?policyId=${this.props.policy_id}`
        );
        let res = await response.json();
        if (res.success) {
          this.setState({
            showCentres: res.costCentres.length > 0,
          });
        } else {
          toastr.error(res.message, "Error");
        }
      } catch (error) {
        toastr.error(error, "Error");
      }
    }
  }
);
